import { UrlParams } from 'utils/url/url.interface'

/**
 * Checks if the user is in a resume context.
 * Returns true if either:
 * - context parameter is 'resume' (e.g., coming from players "search")
 * - resume hash is present in URL parameters
 */
export function isCaptchaOnRender(urlParams?: UrlParams): boolean {
  return urlParams?.context === 'resume' || urlParams?.context === 'offers'
}
